package com.eladfinish.bible.contest.screens.randomVerse.ui

enum class AnimationState {
    OFF,
    RUNNING,
    IDLE,
}
